import React from 'react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">אודות</h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            B2B Store היא חברת מסחר מובילה המתמחה בפתרונות מקצועיים עבור עסקים ולקוחות פרטיים.
            אנחנו מציעים מגוון רחב של מוצרים איכותיים עם שירות מעולה.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
